import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DriverReviewsService {
  constructor(private http: HttpClient) {}

  getDriverReviews(data: any) {
    return this.http.post(environment.apiUrl + "admin/driver/reviews/all", data);
  }
}
